var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-popconfirm', {
    attrs: {
      "title": _vm.title,
      "confirmButtonText": _vm.confirmText,
      "cancelButtonText": _vm.cancelText,
      "icon": _vm.icon,
      "iconColor": _vm.iconColor
    },
    on: {
      "confirm": function ($event) {
        return _vm.$emit('confirm');
      },
      "cancel": function ($event) {
        return _vm.$emit('cancel');
      }
    },
    scopedSlots: _vm._u([{
      key: "reference",
      fn: function () {
        return [_vm._t("default")];
      },
      proxy: true
    }], null, true)
  });

}
var staticRenderFns = []

export { render, staticRenderFns }